<template>
  <div>
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <h4 class="title is-size-5 mr-5 mb-0">Job Titles</h4>
      <BaseDropdown
        v-if="!isSubmitted"
        :leftOffset="-10"
        wrapperClasses="column is-8 pt-0"
        dialogClass="p-0"
        :onDialogChange="chooseJobTitle">
        <template v-slot:toggle-button="{ handleToggle }">
          <div @click="handleToggle" class="pick-job-title-container">... בחר/י</div>
        </template>
        <div class="container py-3 px-2 max-width-dropdown">
          <input type="search" class="input" v-model="searchJobTitle" />
          <label v-for="jobTitle in dropdownJobTitles" :key="jobTitle.id">
            <input type="checkbox" name="skills" :value="jobTitle.id" hidden />
            <p class="search_result has-text-right">{{ jobTitle.name }}</p>
          </label>
        </div>
      </BaseDropdown>
    </div>
    <table class="table rtl" style="width: 100%">
      <tbody>
        <tr v-for="selected in selectedJobTitles" :key="selected.id">
          <td class="has-text-right">{{ selected.name }}</td>
          <td class="px-1" style="width: 350px;">
            <div class="columns is-align-items-center">
              <div>
                <IsPrimary v-if="!isSubmitted" :positionId="position.id" :jobTitleId="selected.id" v-model="selected.is_primary" />
                <div v-else>
                  <span class="is-size-7">{{ selected.is_primary !== undefined && selected.is_primary ? 'Is primary' : 'Not primary' }}</span>
                </div>
              </div>
              <div class="column is-4" v-if="!isSubmitted">
                <input
                  class="input is-small"
                  type="number"
                  style="background-color: white !important;"
                  placeholder="..."
                  v-model.number="selected.min_experience"
                />
                <p class="help">Min experience</p>
              </div>
              <div class="column is-4" v-else>
                <p class="m-1">{{ selected.min_experience }}</p>
                <p class="help">Min experience</p>
              </div>
              <div class="column is-4" v-if="!isSubmitted">
                <input
                  class="input is-small"
                  type="number"
                  style="background-color: white !important;"
                  placeholder="..."
                  v-model.number="selected.max_experience"
                />
                <p class="help">Max experience</p>
                <p v-if="willSwap(selected)" class="help has-text-warning-dark" dir="rtl" data-test="experience-swap-hint">{{ rangeSwapHint }}</p>
              </div>
              <div class="column is-4" v-else>
                <p class="m-1">{{ selected.max_experience }}</p>
                <p class="help">Max experience</p>
              </div>
              <div class="columns">
                <div class="column is-3" v-if="!isSubmitted">
                  <button class="button is-danger is-small" @click="removeJotTitle(selected)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 20 20">
                        <g xmlns="http://www.w3.org/2000/svg" id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="Dribbble-Light-Preview" transform="translate(-179.000000, -360.000000)" fill="#ffffff">
                            <g id="icons" transform="translate(56.000000, 160.000000)">
                              <path d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z" id="delete-[#1487]"></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!isSubmitted">
      <button class="button is-info is-fullwidth" @click="submitJobTitles" :disabled="!valideJobTitles">Submit job titles</button>
    </div>
    <div v-if="isSubmitted">
      <button class="button is-info is-fullwidth" @click="updateJobTitles" :disabled="valideJobTitles">Update job titles</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseDropdown from '@/components/BaseDropdown'
import IsPrimary from '@/components/entities/positionJobTitle/IsPrimary'
import { rangeWillSwap, RANGE_SWAP_HINT } from '@/custom/helpers/range_swap'

export default {
  name: 'PositionJobTitles',
  components: {
    BaseDropdown,
    IsPrimary
  },
  props: {
    position: {
      type: Object
    }
  },
  data () {
    return {
      selectedJobTitles: [],
      searchJobTitle: '',
      isSubmitted: false
    }
  },
  computed: {
    rangeSwapHint () {
      return RANGE_SWAP_HINT
    },
    ...mapGetters('jobTitles', ['allJobTitles']),
    dropdownJobTitles () {
      const selectedIds = this.selectedJobTitles.map(title => title.id)
      return this.allJobTitles.filter(job => {
        return !selectedIds.includes(job.id) && job.name.includes(this.searchJobTitle)
      })
    },
    valideJobTitles () {
      return this.selectedJobTitles.length && !this.isSubmitted
    }
  },
  async created () {
    const result = await this.$network_utils.getPositionJobTitle({ position_id: this.position.id })
    if (result.length) {
      this.isSubmitted = true
    } else {
      this.isSubmitted = false
    }
    this.selectedJobTitles = result.map(el => this.transformJobTitles(el))
    this.notifyParentElement()
  },
  methods: {
    willSwap (selected) {
      return rangeWillSwap(selected.min_experience, selected.max_experience)
    },
    notifyParentElement () {
      this.$emit('updateJobTitles', this.selectedJobTitles)
    },
    transformJobTitles (jobTitle) {
      return { ...jobTitle.job_title, max_experience: jobTitle.max_experience, min_experience: jobTitle.min_experience, server: true }
    },
    updateJobTitles () {
      this.isSubmitted = false
    },
    async chooseJobTitle ({ target: { value: id } }) {
      const jobTitle = this.allJobTitles.find(j => j.id == id)
      if (jobTitle) {
        this.selectedJobTitles.push({ ...jobTitle })
      }
    },
    async submitJobTitles () {
      const requests = this.selectedJobTitles.map(jobTitle => {
        if (jobTitle.server) {
          return this.$network_utils.updatePositionJobTitle({ position_id: this.position.id, job_title_id: jobTitle.id, min_experience: jobTitle.min_experience, max_experience: jobTitle.max_experience })
        }
        return this.$network_utils.postPositionJobTitle({ position_id: this.position.id, job_title_id: jobTitle.id, min_experience: jobTitle.min_experience, max_experience: jobTitle.max_experience })
      }).filter(Boolean)
      const responses = await this.$caller.axios.all(requests)
      responses.forEach(j => {
        const jobTitle = this.selectedJobTitles.find(job => job.id === j.job_title_id)
        jobTitle.server = true
      })
      await this.$network_utils.updatePosition({ position_id: this.position.id, active_at: new Date() })
      this.isSubmitted = true
    },
    async removeJotTitle (jobTitle) {
      if (jobTitle.server) {
        const response = await this.$network_utils.deletePositionJobTitle({ position_id: this.position.id, job_title_id: jobTitle.id })
        this.selectedJobTitles = this.selectedJobTitles.filter(el => el.id !== response.job_title_id)
      } else {
        this.selectedJobTitles = this.selectedJobTitles.filter(el => el.id !== jobTitle.id)
      }
    }
  }
}
</script>

<style scoped>
  .max-width-dropdown {
    max-width: 500px;
    min-width: 250px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    max-height: 400px;
    overflow-y: scroll;
  }
  .pick-job-title-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
  .b-r{
    height: 65vh;
    overflow-y: auto;
  }
</style>
